module.exports = __webpack_public_path__ + "static/media/IMG3.3786d7cf.png";